import { z } from 'zod'
import type { HeadersInput } from '../types'
import type { RoutescanClient } from './client'

type GetBlockNumberByTimestampParameters = {
  client: RoutescanClient
  /** Unix timestamp in seconds */
  timestamp: number
  closest?: 'before' | 'after'
  headers?: HeadersInput
}

const resultSchema = z.string().regex(/^\d+$/).transform(Number)

/** {@link https://docs.etherscan.io/routescan/api-endpoints/blocks#get-block-number-by-timestamp} */
export const getBlockNumberByTimestamp = async ({
  client,
  timestamp,
  closest = 'before',
  headers,
}: GetBlockNumberByTimestampParameters) => {
  const result = await client.get({
    path: '',
    query: {
      module: 'block',
      action: 'getblocknobytime',
      timestamp: timestamp.toString(),
      closest,
    },
    resultSchema,
    headers,
  })
  return result
}
